<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div class="flex align-center justify-between">
          <div class="flex align-center margin-right-sm ">
            <span>竞赛名称：</span>
            <el-input v-model="keyword" placeholder="请输入竞赛名称" class="flex-sub"></el-input>
          </div>

          <el-button type="primary" @click="hanldSearch">搜索</el-button>
        </div>
        <router-link to="/home/competition-edit/0">
          <el-button type="primary">添加竞赛</el-button>
        </router-link>
      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{ total }}条数据
        </div>
        <div>
        </div>
      </div>

      <el-table
        :data="list"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="竞赛名称" prop="name"></el-table-column>
        <el-table-column label="竞赛开始时间" prop="race_start_time" width="180"></el-table-column>
        <el-table-column label="竞赛结束时间" prop="race_end_time" width="180"></el-table-column>
        <el-table-column label="题目数量" prop="question_num" width="100"></el-table-column>
        <el-table-column label="排名" prop="name" width="100">
          <template slot-scope="scope">
            <div class="table-operate" v-if="!scope.row.desc">
              <router-link :to="'/home/competition-ranking/' + scope.row.id">
                <el-button
                  size="small"
                  type="primary"
                >查看排名
                </el-button>
              </router-link>
            </div>

          </template>
        </el-table-column>
        <el-table-column label="竞赛状态" prop="name" width="150">
          <template slot-scope="scope">
            <el-button
              v-if="Number(scope.row.is_show) === 1"
              size="small"
              type="success"
              @click="stateItem(1,scope.row.id)"
            >已发布，点击下线
            </el-button>
            <el-button
              v-else
              size="small"
              type="primary"
              @click="stateItem(2,scope.row.id)"
            >已下线，点击发布
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <div class="table-operate" v-if="!scope.row.desc">

              <el-button
                size="small"
                type="primary"
                @click="editItem(scope.row.id)"
              >编辑
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="delItem(scope.row.id)"
              >删除
              </el-button>
            </div>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="list.length > 0"
        class="page-all"
        background
        @current-change="getList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>


import {delQuestionRace, questionRaceList, setShowQuestionRace} from "@/api/study";

export default {
  name: "competition-list",
  data() {
    return {
      keyword: '',
      question_type: '',
      typeList: [],
      page: 1,
      limit: 10,
      total: 0,
      list: [],
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", this.$route.path, "双暖为老 / 竞赛管理", false);
    this.getList()
  },
  components: {},
  methods: {
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getList()
    },
    //  获取列表
    async getList() {
      const res = await questionRaceList(this.keyword, this.page, this.limit)
      this.list = res.data
      this.total = res.total_number
    },
    //  上线/下线竞赛
    stateItem(state, id) {
      this.$confirm('您确定要' + (state === 2 ? '上线' : '下线') + '该竞赛吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureState(state, id);
      });
    },
    async sureState(state, id) {
      let _state = await setShowQuestionRace(state, id);
      this.getList();
      this.$message.success(_state.info);
    },


    //  添加修改竞赛
    editItem(id) {
      this.$router.push('/home/competition-edit/' + id)
    },
    //  删除竞赛
    delItem(id) {
      this.$confirm('您确定要删除该竞赛吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDel(id);
      });
    },
    async sureDel(id) {
      let _state = await delQuestionRace(id);
      if (this.list.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.info);
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
